import { render, staticRenderFns } from "./JobTemplate.vue?vue&type=template&id=73556636&scoped=true&"
import script from "./JobTemplate.vue?vue&type=script&lang=js&"
export * from "./JobTemplate.vue?vue&type=script&lang=js&"
import style0 from "./JobTemplate.vue?vue&type=style&index=0&id=73556636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73556636",
  null
  
)

export default component.exports